import { createSelector } from "reselect";
import { selectAccountState } from "../accountSelectors";
export const selectQuotationsState = createSelector(selectAccountState, account => account.quotations);
export const selectQuotations = createSelector(selectQuotationsState, quotations => quotations.list);
